import React from 'react';

import { useNavigate } from 'react-router';
import styled from 'styled-components';

import { MainMenuLink as BaseMainMenuLink } from 'components/main-menu-link';
import { useMediaQuery } from 'hooks/use-media-query';
import { useLocationContext } from 'state/location';
import { primitive } from 'styles/constants/primitives';
import { routes } from 'utils/routing';

import { IMainMenuLink } from './types';

const LinkContainer = styled.div<{ section: boolean }>`
  display: flex;
  justify-content: flex-start;
  position: fixed;
  inset-block-start: calc(3px + env(safe-area-inset-top));
  inset-inline-start: ${primitive.$spacing1};
  z-index: ${Styles.zIndex.overlay};
  margin: ${primitive.$spacing4};

  ${Styles.desktop} {
    position: inherit;
    margin-block-start: 0;
    margin-block-end: -${primitive.$spacing7};
    margin-inline: ${primitive.$spacing7};
    justify-content: center;
    z-index: ${Styles.zIndex.below};
  }
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex: 1 1 auto;
  max-width: 1000px;
`;

export const MainMenuLink: React.FC<IMainMenuLink> = ({ backToFullMenu, type }) => {
  const { back } = useLocationContext();
  const isMobile = useMediaQuery('mobile');

  const navigate = useNavigate();
  const onClickCallBack = backToFullMenu ? () => navigate(routes.menu) : back;

  const onClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (isMobile) {
      onClickCallBack();
      e.preventDefault();
    }
  };
  return (
    <LinkContainer section={type === 'section'} data-testid="main-menu-link-container">
      <InnerContainer>
        <BaseMainMenuLink onClick={onClick} />
      </InnerContainer>
    </LinkContainer>
  );
};
